import { lazy, Suspense } from "react"

import { queryClient } from "@/services/queryClient"

const isEnabled = import.meta.env.VITE_DEVTOOLS_ENABLED === "true"

const LazyQueryDevtools = isEnabled
  ? lazy(async () => {
      const { ReactQueryDevtools } = await import("@tanstack/react-query-devtools")
      return { default: ReactQueryDevtools }
    })
  : null

const LazyRouterDevtools = isEnabled
  ? lazy(async () => {
      const { TanStackRouterDevtools } = await import("@tanstack/react-router-devtools")
      return { default: TanStackRouterDevtools }
    })
  : null

export function QueryDevtools() {
  if (!LazyQueryDevtools) return null

  return (
    <Suspense fallback={null}>
      <LazyQueryDevtools client={queryClient} />
    </Suspense>
  )
}

export function RouterDevtools() {
  if (!LazyRouterDevtools) return null

  return (
    <Suspense fallback={null}>
      <LazyRouterDevtools />
    </Suspense>
  )
}
